import { useEffect } from "react";
import { MultiSelection } from "../MultiSelection.jsx";
import { useFormDispatch } from "../../FormContext.jsx";

const DispatchingMultiSelection = ({
  fieldKey,
  formData,
  required,
  setFormData,
  error,
  label,
  description,
  options,
  edit,
}) => {
  const dispatch = useFormDispatch();

  const value = formData[fieldKey];

  useEffect(() => {
    if (error) return;
    dispatch({ type: "updateField", [fieldKey]: value });
  }, [value, fieldKey, dispatch, error]);

  return (
    <MultiSelection
      edit={edit}
      description={description}
      fieldKey={fieldKey}
      label={label}
      formData={formData}
      setFormData={setFormData}
      options={options}
      required={required}
      error={error}
    />
  );
};

export default DispatchingMultiSelection;
